import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { CatalogsAndSchemasField } from './CatalogsAndSchemasField';
import { CatalogConflictGuardField } from './CatalogConflictGuardField';
import {
  collectCatalogConflictErrors,
  type CatalogEntryLike,
} from './catalogNameConflict';

export const CatalogsAndSchemasFieldExtension = FormFieldBlueprint.make({
  name: 'catalogs-and-schemas-field',
  params: {
    field: async () =>
      createFormField({
        name: 'CatalogsAndSchemasField',
        component: CatalogsAndSchemasField,
      }),
  },
});

// Hidden string field whose sole purpose is to host the blocking validation:
// array-typed fields do not reliably receive a validation callback, but scalar
// string fields do. It reads the requested catalogs from the form data.
export const CatalogConflictGuardFieldExtension = FormFieldBlueprint.make({
  name: 'catalog-conflict-guard-field',
  params: {
    field: async () =>
      createFormField({
        name: 'CatalogConflictGuardField',
        component: CatalogConflictGuardField,
        validation: (_value: string | undefined, validation, context) => {
          if (context.formData?.add_existing_catalog === true) {
            const existingCatalogs = context.formData?.existingCatalogs as
              | {
                  workspace?: string;
                  catalog?: string;
                  schemas?: string[];
                }[]
              | undefined;
            if (!existingCatalogs?.length) {
              validation.addError(
                'Select an existing catalog and add schemas for each workspace.',
              );
              return;
            }
            for (const entry of existingCatalogs) {
              if (!entry.catalog) {
                validation.addError(
                  `Select an existing catalog for ${
                    entry.workspace ?? 'each workspace'
                  }.`,
                );
              }
              if (!entry.schemas?.length) {
                validation.addError(
                  `Add at least one schema for ${
                    entry.workspace ?? 'each workspace'
                  }.`,
                );
              }
              for (const schema of entry.schemas ?? []) {
                if (!/^[a-z][a-z0-9_]{1,62}$/.test(schema)) {
                  validation.addError(
                    `Schema name "${schema}" is invalid. Use lowercase letters, numbers, and underscores; start with a letter and use 2 to 63 characters.`,
                  );
                }
              }
            }
            return;
          }
          const catalogs = context.formData?.catalogs as
            | CatalogEntryLike[]
            | undefined;
          for (const message of collectCatalogConflictErrors(catalogs)) {
            validation.addError(message);
          }
        },
      }),
  },
});
